import { UPDATE_DMX_PROFILE, UPDATE_DMX_PROFILE_SUCCESSFUL, UPDATE_DMX_PROFILE_FAILED } from './actionTypes';

const initialState = {
  updateDmxProfileError: null,
  messageDmxProfile: null,
  loadingUpdateDmxProfile: false,
};

const updateProfile = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DMX_PROFILE:
      state = { ...state, loadingUpdateDmxProfile: true, updateDmxProfileError: null };
      break;
    case UPDATE_DMX_PROFILE_SUCCESSFUL:
      state = { ...state, loadingUpdateDmxProfile: false, messageDmxProfile: action.payload, updateDmxProfileError: null };
      break;
    case UPDATE_DMX_PROFILE_FAILED:
      state = { ...state, messageDmxProfile: null, loadingUpdateDmxProfile: false, updateDmxProfileError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateProfile;
